module.exports = __webpack_public_path__ + "img/1.cde71a5c.jpg";